import React, { useState, useEffect } from "react";
import { Col, Container, Row, Form } from "react-bootstrap";
import { TextInputForm } from "../../components/Forms";
import { ClickButton } from "../../components/ClickButton";
import PageNav from "../../components/PageNav";
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import API_DOMAIN from "../../config/config";
import "react-toastify/dist/ReactToastify.css";

const DanceClassBillCreation = () => {
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const navigate = useNavigate();

  const getTodayDate = () => new Date().toISOString().split("T")[0];

  const initialState =
    type === "edit"
      ? {
          dance_class_bill_no: rowData.dance_class_bill_no,
          dance_class_bill_date:
            rowData.dance_class_bill_date || getTodayDate(),
          class_name: rowData.class_name,
          parent_name: rowData.parent_name,
          child_name: rowData.child_name,
          amount: rowData.amount,
          towards: rowData.towards,
        }
      : {
          dance_class_bill_no: "",
          dance_class_bill_date: getTodayDate(),
          class_name: "",
          parent_name: "",
          child_name: "",
          amount: "",
          towards: "Admission Fee",
        };

  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);

  const handleChange = (e, field) => {
    const value = e.target ? e.target.value : e.value;
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    if (!formData.dance_class_bill_no || !formData.amount) {
      toast.error("Bill Number and Amount are required!");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        ...formData,
        ...(type === "edit"
          ? { edit_bill_id: rowData.dance_class_bill_id }
          : {}),
      };

      const response = await fetch(`${API_DOMAIN}/dance_class_bills.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      if (result.head.code === 200) {
        toast.success(result.head.msg);
        setTimeout(() => navigate("/console/master/danceclassbill"), 1000);
      } else {
        toast.error(result.head.msg || "Failed to save bill");
      }
    } catch (err) {
      toast.error("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Container>
        <Row className="regular">
          <Col lg="12" className="py-3">
            <PageNav
              pagetitle={`${type === "edit" ? "Edit" : "Create"} Dance Class Bill`}
            />
          </Col>
          <Col lg="4" className="py-3">
            <TextInputForm
              labelname="Bill No"
              value={formData.dance_class_bill_no}
              onChange={(e) => handleChange(e, "dance_class_bill_no")}
              disabled={type === "edit"}
            />
          </Col>
          <Col lg="4" className="py-3">
            <label className="form-label">Date</label>
            <input
              type="date"
              className="form-control"
              value={formData.dance_class_bill_date}
              onChange={(e) => handleChange(e, "dance_class_bill_date")}
            />
          </Col>
          <Col lg="4" className="py-3">
            <label className="form-label">Class Name</label>
            <Form.Select
              value={formData.class_name}
              onChange={(e) => handleChange(e, "class_name")}
              aria-label="Default select example"
            >
              <option value="">Select Class</option>
              <option value="பரதநாட்டியம்">பரதநாட்டியம்</option>
              <option value="வாய்ப்பாட்டு">வாய்ப்பாட்டு</option>
              <option value="வீணை">வீணை</option>
              <option value="கீபோர்டு">கீபோர்டு</option>
            </Form.Select>
          </Col>
          <Col lg="4" className="py-3">
            <TextInputForm
              labelname="Parent Name"
              value={formData.parent_name}
              onChange={(e) => handleChange(e, "parent_name")}
            />
          </Col>
          <Col lg="4" className="py-3">
            <TextInputForm
              labelname="Student Name"
              value={formData.child_name}
              onChange={(e) => handleChange(e, "child_name")}
            />
          </Col>
          <Col lg="4" className="py-3">
            <TextInputForm
              labelname="Amount"
              value={formData.amount}
              onChange={(e) => handleChange(e, "amount")}
              type="text"
            />
          </Col>
          <Col lg="4" className="py-3">
            <TextInputForm
              labelname="Towards"
              value={formData.towards}
              onChange={(e) => handleChange(e, "towards")}
            />
          </Col>

          <Col
            lg="12"
            className="text-center py-3 d-flex justify-content-center gap-3"
          >
            <ClickButton
              label={
                loading ? "Saving..." : type === "edit" ? "Update" : "Submit"
              }
              onClick={handleSubmit}
              disabled={loading}
            />
            <ClickButton
              label="Cancel"
              onClick={() => navigate("/console/master/danceclassbill")}
              disabled={loading}
            />
          </Col>
        </Row>
        <ToastContainer />
      </Container>
    </div>
  );
};

export default DanceClassBillCreation;
